const BenefitLifeManage = () => import('@/views/benefitLife/benefitLifeManageList.vue')

function route(path, title, entity) {
  return {
    path,
    meta: { title, entity },
    name: path,
    component: BenefitLifeManage
  }
}

export default [
  route('/pages/benefitLife/manage', '惠生活', 'merchant'),
  route('/pages/benefitLife/merchant', '商家管理', 'merchant'),
  route('/pages/benefitLife/category', '商品分类', 'category'),
  route('/pages/benefitLife/product', '商品管理', 'product'),
  route('/pages/benefitLife/groupBuy', '团购管理', 'groupBuy'),
  route('/pages/benefitLife/order', '订单管理', 'order'),
  route('/pages/benefitLife/integralRule', '积分规则', 'integralRule'),
  route('/pages/benefitLife/integralAccount', '积分账户', 'integralAccount'),
  route('/pages/benefitLife/integralDetail', '积分流水', 'integralDetail'),
  route('/pages/benefitLife/integralDeduction', '积分抵扣', 'integralDeduction'),
  route('/pages/benefitLife/couponSupplier', '卡券供应商', 'couponSupplier'),
  route('/pages/benefitLife/coupon', '卡券资源', 'coupon'),
  route('/pages/benefitLife/couponUser', '卡券领取', 'couponUser'),
  route('/pages/benefitLife/secondhand', '二手物品', 'secondhand'),
  route('/pages/benefitLife/secondhandTrade', '二手交易', 'secondhandTrade'),
  route('/pages/benefitLife/mutualTask', '互助任务', 'mutualTask'),
  route('/pages/benefitLife/commission', '佣金流水', 'commission')
]
